import React from 'react';

export function InsertVideoButton({ theme, store, getWidget }) {
	const editorState = store.getEditorState();
	const openInsertWidget = (evt) => {
		const videoWidget= getWidget('video-bar');
		const button = evt.target;
		const buttonPosition = Math.floor(button.offsetLeft + button.clientWidth / 2);
		videoWidget.getInstance().open(buttonPosition);
	};
	return (
		<div
			className={theme.buttonWrapper}
			onClick={e => e.stopPropagation()}
			title="插入视频">
			<button
				className={theme.button}
				onClick={openInsertWidget}>
				<i className="qa-ico-video">V</i>
			</button>
		</div>
	);
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/videoPlugin/InsertVideoButton.jsx